import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  SubTitleLarge,
  BodyLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {
  CONSTANTS,
  getTranslatedText,
} from 'src/components/authentication/contants';

import ResetImage from 'src/images/reset-phone-icon.svg';
import css from './phone-reset-confirmation.css';


const PhoneResetConfirmation = () => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.PhoneResetConfirmationPage}>
      <ResetImage />
      <SubTitleLarge className={css.titleText}>
        {getTranslatedText(t, CONSTANTS.PHONE_RESET_TITLE)}
      </SubTitleLarge>
      <BodyLarge className={css.infoText}>
        {getTranslatedText(t, CONSTANTS.PHONE_RESET_SUBTEXT)}
      </BodyLarge>
    </div>
  );
};

export default PhoneResetConfirmation;
